import { render, staticRenderFns } from "./intro_to_529s.vue?vue&type=template&id=6e632bfa&scoped=true&lang=pug&"
import script from "./intro_to_529s.vue?vue&type=script&lang=js&"
export * from "./intro_to_529s.vue?vue&type=script&lang=js&"
import style0 from "./intro_to_529s.vue?vue&type=style&index=0&id=6e632bfa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e632bfa",
  null
  
)

export default component.exports